import React, { useState, useEffect, useContext } from 'react'
import { AuthContext } from '../../context/auth-context'
import { NavLink } from 'react-router-dom'
import { useForm } from '../../hooks/http-hook'
import { useHttpClient } from '../../hooks/http-hook'
import { Helmet } from 'react-helmet-async'
import './Home.css'
import Footer from '../UIElements/Footer'
import HomeHomeNavigation from './HomeHomeNavigation'
import LoadingSpinner from '../UIElements/LoadingSpinner'
import ErrorModal from '../UIElements/ErrorModal'
import YouTube from 'react-youtube'
import Carousel from 'react-bootstrap/Carousel'
import logo from '../images/PH_logo_gray_background.jpg'
import waiver from '../images/Greater Pittsburgh Dek Hockey waiver.pdf'
var getYouTubeID = require('get-youtube-id')

const Home = () => {
	const [isLoading, setIsLoading] = useState(false)
	const auth = useContext(AuthContext)
	const [pic1, setPic1] = useState()
	const [pic2, setPic2] = useState()
	const [error, setError] = useState()
	const [ids, setIds] = useState([])
	const [videoTitles, setVideoTitles] = useState([])
	const [videoCaptions, setVideoCaptions] = useState([])
	const [loadedVideos, setLoadedVideos] = useState([])
	const [loadedNews, setLoadedNews] = useState([])
	const [loadedCarouselPhotos, setLoadedCarouselPhotos] = useState([])
	//console.log('auth: ' + JSON.stringify(auth))

	//Get all videos designated for the Home Page
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/homePageVideos',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedVideos(responseData.allHomePageVideos)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			//
			setIsLoading(false)
		}

		sendRequest()
	}, [])
	//
	//
	//
	//Get all Carousel photos
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/carouselPhotos',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedCarouselPhotos(responseData.allCarouselPhotos)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			//
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//
	loadedCarouselPhotos &&
		console.log('loadedCarouselPhotos: ' + JSON.stringify(loadedCarouselPhotos))
	//
	//
	//
	//
	//Get pic 1 and 2
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/getPics12',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				console.log('responseData: ' + JSON.stringify(responseData))

				setPic1(responseData.pic1)
				setPic2(responseData.pic2)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			//
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//
	//
	//
	//
	//
	let arrayOfTitles, arrayOfIds, arrayOfCaptions
	arrayOfTitles = []
	arrayOfIds = []
	arrayOfCaptions = []
	if (loadedVideos && !isLoading && ids.length === 0) {
		loadedVideos.forEach((video) => {
			arrayOfTitles.push(video.videoTitle)
			arrayOfIds.push(getYouTubeID(video.videoURL))
			arrayOfCaptions.push(video.videoCaption)
		})
	}

	if (arrayOfTitles.length > 0) {
		setVideoTitles(arrayOfTitles)
	}
	if (arrayOfIds.length > 0) {
		setIds(arrayOfIds)
	}
	if (arrayOfCaptions.length > 0) {
		setVideoCaptions(arrayOfCaptions)
	}
	//
	//
	//
	//
	//
	//
	//
	//Get all News
	useEffect(() => {
		const sendRequest2 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/news',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedNews(responseData.allNews)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			//
			setIsLoading(false)
		}

		sendRequest2()
	}, [])
	//
	//
	//
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<Helmet>
					<title>Greater Pitt Dek Hockey</title>
					<meta
						name='description'
						content='Greater Pitt Dek Hockey, Penn Hills Dek Hockey, GPDC, penn hills dek hockey'
					/>
					<meta
						name='keywords'
						content='Greater Pitt Dek Hockey, Penn Hills Dek Hockey, GPDC'
					/>
					<meta
						property='og:url'
						content='https://greaterpittdekhockey.web.app/'
					/>
					<meta property='og:site_name' content='Greater Pitt Dek Hockey' />
					<meta property='og:locale' content='en_US' />
				</Helmet>
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && <LoadingSpinner asOverlay />}
				{!isLoading && (
					<div>
						<header className='homeHeader'>
							<HomeHomeNavigation />
							<div className='text-light text-md-right text-center banner headingWriting'></div>
						</header>
						{/* <div className='section pt-5'>
							<div className=''>
								<div className='row'>
									<div>
										<img src={logo} className='logo' />
									</div>
								</div>
								<div className='row'>
									<div className='col'>
										<h4
											className='newsAndUpdates'
											style={{
												textAlign: 'center',
												color: 'black',
												marginLeft: '15%',
												marginRight: '15%',
											}}
										>
											The Premier Dek Hockey Organization of Pittsburgh
										</h4>
									</div>
								</div>
								<div className='row'>
									<div className='col'>
										<h5
											className='newsAndUpdates'
											style={{
												textAlign: 'center',
												color: 'black',
												marginLeft: '15%',
												marginRight: '15%',
												marginTop: '1.5rem',
												marginBottom: '1rem !important',
											}}
										>
											As of May 2024:
										</h5>
									</div>
								</div>
								<div className='row'>
									<div className='col'>
										<p className='paragraph'>
											Youth In-House cost is now $65 per player for 10 games
											plus playoffs. (1st round single elimination, finals will
											be best of 3).{' '}
											<strong>New players are $25 and GOALIES NOW FREE!</strong>
											<br></br>
											<br></br>
											<strong>Chipmunk is $20</strong>
											<br></br>
											<br></br>
											Payment is due in the pro shop the first day of the
											season! Divisions are as follows and determined by your
											age as of January 1, 2024 or the birth years listed:
										</p>
									</div>
								</div>
								<div className='row'>
									<div className='col'>
										<p className='divisions'>
											<strong>Chipmunk (2017 - 2019) Tuesdays at 6:30</strong>
											<br></br>
											<strong>Penguin (2014 - 2016) Mondays at 6:30</strong>
											<br></br>
											<strong>Beaver (2011 - 2013) Thursdays at 6:30</strong>
											<br></br>
											<strong>Cadet (2008 - 2010) Thursdays at 7:30</strong>
										</p>
									</div>
								</div>
								<div className='row'>
									<div className='col-lg-3 col-sm-6'></div>
									{!isLoading &&
										loadedNews &&
										loadedNews.map((news, key) => {
											return (
												<div>
													<h1 style={{ color: 'red' }}>{news.newsHeading}</h1>

													<p
														className='caption'
														style={{
															textAlign: 'center',
															color: 'black',
														}}
													>
														{news.newsSubheading}
													</p>
													<p
														className='caption'
														style={{
															textAlign: 'center',
															color: 'black',
														}}
													>
														{news.newsDate}
													</p>
													<p
														className='content'
														style={{
															textAlign: 'center',
															color: 'black',
															marginBottom: '3rem',
															whiteSpace: 'pre-wrap',
														}}
													>
														{news.newsContent}
													</p>
												</div>
											)
										})}
									<div className='col-lg-3 col-sm-6'></div>
								</div>
							</div>
						</div> */}
						<div className='section pt-5'>
							<div className='row'>
								<div>
									<img src={logo} className='logo' />
								</div>
							</div>
							<div className=''>
								<div className='row'>
									<div className='col text-center mb-3'>
										<h1
											// className='display-4 lead headingText'
											className='display-2'
											style={{
												fontWeight: '600',
												color: '#f6c24e',
												textShadow: '2px 2px 2px #410009',
											}}
										>
											News and Updates
										</h1>
									</div>
								</div>
								{/* //
								//
								//    NEWS CAROUSEL
								//
								// */}
								<div className='section'>
									<div className='row'>
										<div className='col-lg-3 col-sm-6'></div>
										{!isLoading && loadedNews && (
											<Carousel>
												{loadedNews.map((news, key) => (
													<Carousel.Item interval={7000}>
														<div>
															<h1 style={{ color: 'red' }}>
																{news.newsHeading}
															</h1>

															<p
																className='caption'
																style={{
																	textAlign: 'center',
																	color: 'black',
																}}
															>
																{news.newsSubheading}
															</p>
															<p
																className='caption'
																style={{
																	textAlign: 'center',
																	color: 'black',
																}}
															>
																{news.newsDate}
															</p>
															<p
																className='content'
																style={{
																	textAlign: 'center',
																	color: 'black',
																	marginBottom: '3rem',
																	whiteSpace: 'pre-wrap',
																}}
															>
																{news.newsContent}
															</p>
														</div>
													</Carousel.Item>
												))}
											</Carousel>
										)}
										<div className='col-lg-3 col-sm-6'></div>
									</div>
								</div>
							</div>
							<div className='row'>
								<a
									href='https://docs.google.com/forms/d/e/1FAIpQLSdCDuGumIqIBL9BzxeVJ0T1FVMdY79DPVXc-KAO0N38Yk9uMg/viewform'
									className='centeredButtonSmallMargin commitmentFormButton'
									target='_blank'
									style={{
										display: 'block',
										width: 'auto',
										fontWeight: '700',
										backgroundColor: 'red',
										color: 'white',
										borderRadius: '4px',
										textDecoration: 'none',
										boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.4)',
									}}
								>
									2026 Midwest Regionals Waiver
								</a>
							</div>
						</div>
						<div className='row' style={{ marginTop: '0.75rem' }}>
							<a
								href={waiver}
								download
								target='_blank'
								rel='noreferrer'
								style={{
									marginBottom: '3rem',
									textAlign: 'center',
									display: 'block',
									width: '100%',
									fontWeight: '600',
									color: '#000',
									textDecoration: 'underline',
								}}
							>
								Download Midwest Regionals Waiver PDF
							</a>
						</div>
						{/* //
							//
							<!-- promotional video -->
					 */}
						<div className='section pt-5'>
							<div className='container-fluid' style={{ height: 'auto' }}>
								<div className='row'>
									{/* Pic One */}
									<div
										className='col-lg-4 siteBox'
										style={{ marginBottom: '1rem' }}
									>
										<img
											src={`${process.env.REACT_APP_AWS_BUCKET}/${pic1}`}
											className='img-thumbnail'
										/>
										{auth.isLoggedIn && (
											<NavLink
												className='changePicButton'
												to={`/admin/pic1Photo`}
												exact
												style={{
													textAlign: 'center',
													display: 'block',
													marginRight: 'auto',
													marginLeft: 'auto',
												}}
											>
												Change Photo
											</NavLink>
										)}
									</div>
									<div className='col-lg-4 col-sm-12 text-center siteBox'>
										{
											<YouTube
												className='video'
												style={{ paddingBottom: '3rem' }}
												videoId={getYouTubeID(
													'https://www.youtube.com/watch?v=zoA0b1XM1Yc',
												)}
											/>
										}
									</div>
									{/* Pic Two */}
									<div
										className='col-lg-4 siteBox'
										style={{ marginBottom: '1rem' }}
									>
										<img
											src={`${process.env.REACT_APP_AWS_BUCKET}/${pic2}`}
											className='img-thumbnail'
										/>
										{auth.isLoggedIn && (
											<NavLink
												className='changePicButton'
												to={`/admin/pic2Photo`}
												exact
												style={{
													textAlign: 'center',
													display: 'block',
													marginRight: 'auto',
													marginLeft: 'auto',
												}}
											>
												Change Photo
											</NavLink>
										)}
									</div>
								</div>
							</div>
						</div>
						{/* //
						//
						//
						//     CAROUSEL
						//
						//
						//
						// */}
						<div className='section pt-5'>
							<div className=''>
								<div className='row'>
									<div className='col text-center mb-3'>
										<h1
											className='display-2'
											style={{
												fontWeight: '600',
												color: '#f6c24e',
												textShadow: '2px 2px 2px #410009',
											}}
										>
											2025 Tournament Champions
										</h1>
									</div>
								</div>
								{/* //
								//
								//
								//   2025 CAROUSEL
								//
								//
								// */}
								<div className='section'>
									<div className='row'>
										<div className='col-lg-3 col-sm-6'></div>
										{!isLoading && loadedCarouselPhotos && (
											<Carousel>
												{loadedCarouselPhotos.map(
													(photo, key) =>
														photo.year === 2025 && (
															<Carousel.Item interval={7000}>
																<img
																	className='d-block carouselPhoto'
																	src={`${process.env.REACT_APP_AWS_BUCKET}/${photo.photo}`}
																	alt='Image One'
																/>
															</Carousel.Item>
														),
												)}
											</Carousel>
										)}
										<div className='col-lg-3 col-sm-6'></div>
									</div>
								</div>
							</div>
						</div>
						{/* //
						//
						//
						//    END OF 2025 CAROUSEL
						//
						//
						//
						// */}
						{/* //
						//
						//
						//     2024 CAROUSEL
						//
						//
						//
						// */}
						<div className='section pt-5'>
							<div className=''>
								<div className='row'>
									<div className='col text-center mb-3'>
										<h1
											className='display-2'
											style={{
												fontWeight: '600',
												color: '#f6c24e',
												textShadow: '2px 2px 2px #410009',
											}}
										>
											2024 Tournament Champions
										</h1>
									</div>
								</div>
								{/* //
								//
								// */}
								<div className='section'>
									<div className='row'>
										<div className='col-lg-3 col-sm-6'></div>
										{!isLoading && loadedCarouselPhotos && (
											<Carousel>
												{loadedCarouselPhotos.map(
													(photo, key) =>
														photo.year === 2024 && (
															<Carousel.Item interval={7000}>
																<img
																	className='d-block carouselPhoto'
																	src={`${process.env.REACT_APP_AWS_BUCKET}/${photo.photo}`}
																	alt='Image One'
																/>
															</Carousel.Item>
														),
												)}
											</Carousel>
										)}
										<div className='col-lg-3 col-sm-6'></div>
									</div>
								</div>
							</div>
						</div>
						{/* //
						//
						//
						//    END OF 2024 CAROUSEL
						//
						//
						//
						// */}
						{loadedVideos.length > 0 && (
							<div
								className='section pt-5'
								style={{ backgroundColor: '#e0e0e0' }}
							>
								<div className=''>
									<div className='row'></div>

									<div className='row'>
										<div className='col-lg-3 col-sm-3'></div>
										<div className='col-lg-6 col-sm-6'>
											{!isLoading &&
												loadedVideos &&
												loadedVideos.map((video, key) => {
													return (
														<div>
															<div className='col text-center mb-0'>
																<h1 className='text-sh-dark display-2'>
																	Watch!
																</h1>
															</div>
															<h1 style={{ color: 'red' }}>
																{video.videoTitle}
															</h1>

															<p
																className='caption'
																style={{
																	textAlign: 'center',
																	color: 'black',
																}}
															>
																{video.videoCaption}
															</p>
															{
																<YouTube
																	style={{ paddingBottom: '3rem' }}
																	videoId={ids[key]}
																/>
															}
														</div>
													)
												})}
										</div>
										<div className='col-lg-3 col-sm-3'></div>
									</div>
								</div>
							</div>
						)}
						<div
							className='section pt-5 videos'
							style={{ paddingBottom: '4rem' }}
						>
							<div className=''>
								<div className='row'>
									<div className='col text-center mb-0'>
										<h1 className='watch display-2'>Come Join Us!</h1>
									</div>
								</div>
								<div className='row'>
									<div className='col'>
										<h4
											className='newsAndUpdates'
											style={{
												textAlign: 'center',
												color: 'black',
												marginLeft: '15%',
												marginRight: '15%',
											}}
										>
											517 Twin Oak Drive
											<br></br>
											Penn Hills, PA 15235
											<br></br>
											<a
												className='phoneNumber'
												href={'tel:4127939800'}
												style={{ textAlign: 'center', fontSize: 'medium' }}
											>
												412-793-9800
											</a>
											<div style={{ textAlign: 'center', fontSize: 'medium' }}>
												pennhillsballhockey@gmail.com
											</div>
										</h4>
									</div>
								</div>
							</div>
						</div>
						{/* //
				//
				//
				// */}
						{/* <div className='section p-5 container-gray'></div> */}
					</div>
				)}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default Home
